import React from "react";

export default function PageHeader({ icon: Icon, title, subtitle }) {
  return (
    <div
      className="flex items-center justify-between pl-16 sm:pl-6 md:pl-8 pr-4 sm:pr-6 md:pr-8 py-4 sm:py-5"
      style={{
        backgroundColor: "#0049A8",
        borderBottom: "2px solid #00B0B0",
      }}
      data-testid="page-header"
    >
      <div className="flex items-center gap-[10px] sm:gap-[14px] min-w-0">
        {Icon && (
          <div
            className="flex items-center justify-center flex-shrink-0"
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              backgroundColor: "rgba(255,255,255,0.15)",
            }}
          >
            <Icon size={22} color="#fff" />
          </div>
        )}
        <div className="min-w-0">
          <div className="text-lg sm:text-xl md:text-2xl" style={{ color: "#fff", fontWeight: 800, letterSpacing: 0.5 }}>
            {title}
          </div>
          {subtitle && (
            <div style={{ color: "#7BA3C7", fontSize: 13, marginTop: 2 }} className="hidden sm:block">{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
}
